import { getProducts, getPayUrl, getPayResult } from '@/api/pay'
//   import { getToken, setToken, removeToken } from '@/util/auth'

const user = {
  state: {
    products: [],
    payUrl: '',
    downloadUrl: ''
  },

  mutations: {
    SET_PRODUCTS: (state, products) => {
      state.products = products
    },
    SET_PAY_URL: (state, payUrl) => {
      state.payUrl = payUrl
    },
    SET_DOWNLOAD_URL: (state, downloadUrl) => {
      state.downloadUrl = downloadUrl
    }
  },

  actions: {
    // 获取产品列表
    GetProducts({ commit }) {
      return new Promise((resolve, reject) => {
        getProducts()
          .then(res => {
            commit('SET_PRODUCTS', res.Data.ProductModels)
            commit('SET_DOWNLOAD_URL', res.Data.DownLoadPackageUrl)
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取付款二维码url
    GetPayUrl({ commit }, productId) {
      return new Promise((resolve, reject) => {
        getPayUrl(productId)
          .then(res => {
            commit('SET_PAY_URL', res.Data.PayUrl)
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    GetPayResult({commit}, out_trade_no) {
      return new Promise((resolve, reject) => {
        getPayResult(out_trade_no)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}

export default user
